import { Action } from '@ngrx/store';
import { RmsOrderResponse } from '@cemex-core/cmx-api';

export enum RmsOrderActionTypes {
  REQUEST = '[Rms Order] Request',
  REQUEST_COMPLETE = '[Rms Order] Request complete',
  RESET = '[Rms Order] Reset',
}

export class RmsOrderLoadAction implements Action {
  readonly type = RmsOrderActionTypes.REQUEST;

  constructor() {}
}

export class RmsOrderLoadCompleteAction implements Action {
  readonly type = RmsOrderActionTypes.REQUEST_COMPLETE;

  constructor(public payload: RmsOrderResponse) {}
}

export class RmsOrderResetAction implements Action {
  readonly type = RmsOrderActionTypes.RESET;

  constructor() {}
}

export type RmsOrderActions = RmsOrderLoadAction | RmsOrderLoadCompleteAction | RmsOrderResetAction;
